<template>
  <GeneralLayout>
    <div class="sidebar-container">
      <MenuTemplate/>
    </div>
    <div class="main-container">
      <div class="main-content">
        <SidebarLayout/>
      </div>
    </div>
  </GeneralLayout>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import GeneralLayout from '@shared/components/layouts/general.layout.vue';
import SidebarLayout from '@shared/components/layouts/sidebar.layout.vue';
import {MenuTemplate} from '@shared/components/templates';

export default defineComponent({
  name: 'AccountLayout',
  components: {
    GeneralLayout,
    SidebarLayout,
    MenuTemplate,
  },
  data() {
    return {
      update: null,
      show: false,
    };
  },
  computed: {},
  methods: {},
});

</script>

<style lang="scss" scoped>

$check-circle: "%3Csvg class='svg-inline--fa fa-check-circle fa-w-16' fill='%23babdcd' aria-hidden='true' focusable='false' data-prefix='fas' data-icon='check-circle' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath class='' fill='23FFFFFF' d='M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z'%3E%3C/path%3E%3C/svg%3E";
$circle: "%3Csvg class='svg-inline--fa fa-circle fa-w-16' aria-hidden='true' fill='%23babdcd' focusable='false' data-prefix='fal' data-icon='circle' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath class='' d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z'%3E%3C/path%3E%3C/svg%3E";

.main-container {
  display: flex;
  padding-left: 65px;
  text-align: left;

  & > .main-content {
    width: 100%;
    position: relative;
  }

  & > .aside-content {
    min-height: 100vh;
    width: 445px;
    border-left: 1px solid var(--light-300);
  }
}

.sidebar-container {
  transition: width .28s;
  width: 65px !important;
  background-color: transparent;
  border-right: 1px solid var(--light-300);
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;

}

</style>
